function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject, _templateObject2, _templateObject3;
var _excluded = ["addTags", "allowBackspaceRemove", "allowCustomValue", "allowDelimited", "allowDuplicates", "allowTagsOnBlur", "allowTagsOnPaste", "bodyProps", "className", "clearTags", "comboboxProps", "delimiter", "disabled", "duplicateCheck", "error", "errorProps", "headerProps", "height", "helpText", "helpTextProps", "id", "initialTags", "labelPosition", "labelProps", "labels", "loading", "locale", "look", "onTagged", "options", "readOnly", "required", "search", "showLabel", "tagFormatter", "textareaProps"],
  _excluded2 = ["allowBackspaceRemove", "allowCustomValue", "allowDelimited", "allowDuplicates", "allowTagsOnBlur", "allowTagsOnPaste", "labelPosition", "look", "search", "showLabel"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useRef, useState, useEffect, useContext } from 'react';
import styled, { css, ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import { BrandfolderHexColors } from "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import { PillSize } from "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import { useClickInside } from "../../../../hooks/use-click-inside.js";
import { useDebounce } from "../../../../hooks/use-debounce.js";
import { generateKey } from "../../../../utilities/key.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { useIntersectionObserver } from "../../../../hooks/use-intersection-observer.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import 'react-transition-group';
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import 'react-laag';
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import '@brandfolder/utilities';
import "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import { StandardPill } from "../../../atoms/pill/standard/standard-pill.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import { FakeTextarea } from "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import { TextfieldBody } from "../../../internal/textfield/textfield-body.js";
import { TextfieldHeader } from "../../../internal/textfield/textfield-header.js";
import "../../../internal/textfield/textfield-icon.js";
import "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { StandardCombobox } from "../../combobox/standard-combobox/standard-combobox.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var DEFAULT_DUPLICATE_CHECK = function DEFAULT_DUPLICATE_CHECK(options) {
  return options.tag.value.toString().trim().toLocaleLowerCase(options.locale) === options.value.trim().toLocaleLowerCase(options.locale);
};
/**
 * Newline, carriage return, comma, semicolon, pipe.
 * Intentionally not delimiting on `@` and `.` for emails.
 * Intentionally not delimited on `:` for URL's.
 */
var DEFAULT_DELIMITER = /[\n\r,;|]/;
var BaseStandardTagger = function BaseStandardTagger(props) {
  var _fakeTextareaRef$curr3, _fakeTextareaRef$curr4, _classnames;
  var addTags = props.addTags,
    allowBackspaceRemove = props.allowBackspaceRemove,
    allowCustomValue = props.allowCustomValue,
    allowDelimited = props.allowDelimited,
    allowDuplicates = props.allowDuplicates,
    allowTagsOnBlur = props.allowTagsOnBlur,
    allowTagsOnPaste = props.allowTagsOnPaste,
    bodyProps = props.bodyProps,
    className = props.className,
    clearTags = props.clearTags,
    comboboxProps = props.comboboxProps,
    _props$delimiter = props.delimiter,
    delimiter = _props$delimiter === void 0 ? DEFAULT_DELIMITER : _props$delimiter,
    disabled = props.disabled,
    duplicateCheck = props.duplicateCheck,
    error = props.error,
    errorProps = props.errorProps,
    headerProps = props.headerProps,
    height = props.height,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    id = props.id,
    initialTags = props.initialTags,
    labelPosition = props.labelPosition,
    labelProps = props.labelProps,
    labels = props.labels,
    loading = props.loading,
    locale = props.locale,
    look = props.look,
    onTagged = props.onTagged,
    _props$options = props.options,
    options = _props$options === void 0 ? [] : _props$options,
    readOnly = props.readOnly,
    required = props.required,
    search = props.search,
    showLabel = props.showLabel,
    tagFormatter = props.tagFormatter,
    textareaProps = props.textareaProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var duplicateOptionLabel = labels.duplicateOptionLabel,
    emptyLabel = labels.emptyLabel,
    iconButtonLabel = labels.iconButtonLabel,
    label = labels.label,
    listboxLabel = labels.listboxLabel,
    loaderLabel = labels.loaderLabel,
    removeTagLabel = labels.removeTagLabel,
    requiredLabel = labels.requiredLabel;
  var enabled = !disabled && !readOnly;
  var hasError = !!error;
  var hasHelpText = !!helpText;
  var hasHeight = height !== undefined;
  var hasRequired = required && !!requiredLabel;
  var helpTextId = "".concat(id, "-help-text");
  var inlineAlertId = "".concat(id, "-inline-alert");
  var labelId = "".concat(id, "-label");
  var textareaId = "".concat(id, "-textarea");
  var textfieldWrapperId = "".concat(id, "-textfield-wrapper");
  var comboboxTextareaRef = useRef(null);
  var fakeTextareaRef = useRef(null);
  var wrapperRef = useRef(null);
  var _useClickInside = useClickInside({
      ref: wrapperRef
    }),
    clickedInside = _useClickInside.clickedInside;
  var _useIntersectionObser = useIntersectionObserver({
      intersectionObserverOptions: {
        root: fakeTextareaRef.current,
        threshold: 0.5
      },
      ref: comboboxTextareaRef
    }),
    intersecting = _useIntersectionObser.intersecting;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    duplicate = _useState2[0],
    setDuplicate = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focused = _useState4[0],
    setFocused = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    expanded = _useState6[0],
    setExpanded = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    overflow = _useState8[0],
    setOverflow = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    reset = _useState10[0],
    setReset = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    selectedAllTags = _useState12[0],
    setSelectedAllTags = _useState12[1];
  var _useState13 = useState(undefined),
    _useState14 = _slicedToArray(_useState13, 2),
    selectedTagIndex = _useState14[0],
    setSelectedTagIndex = _useState14[1];
  var _useState15 = useState(initialTags || []),
    _useState16 = _slicedToArray(_useState15, 2),
    tags = _useState16[0],
    setTags = _useState16[1];
  var _useState17 = useState(undefined),
    _useState18 = _slicedToArray(_useState17, 2),
    toggleExpanded = _useState18[0],
    setToggleExpanded = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    value = _useState20[0],
    setValue = _useState20[1];
  // this debounce is only applied when the combobox input has no value
  // so that a user pressing backspace doesn't remove a tag accidentally
  var valueDebounced = useDebounce(value, value === '' ? 300 : 0);
  var hasSelectedTagIndex = selectedTagIndex !== undefined;
  var hasTags = tags.length > 0;
  var hasValue = value !== '';
  var hasValueDebounced = valueDebounced !== '';
  var lastTagIndex = tags.length - 1;
  var scrollToCombobox = function scrollToCombobox() {
    if (!intersecting) {
      var _comboboxTextareaRef$;
      comboboxTextareaRef === null || comboboxTextareaRef === void 0 || (_comboboxTextareaRef$ = comboboxTextareaRef.current) === null || _comboboxTextareaRef$ === void 0 || _comboboxTextareaRef$.scrollIntoView({
        behavior: 'auto',
        block: 'end'
      });
    }
  };
  var focusCombobox = function focusCombobox() {
    if (comboboxTextareaRef.current) {
      comboboxTextareaRef.current.focus({
        preventScroll: true
      });
    }
  };
  var deselectTags = function deselectTags() {
    if (allowBackspaceRemove) {
      setSelectedAllTags(false);
      setSelectedTagIndex(undefined);
    }
  };
  var resetTagger = function resetTagger() {
    deselectTags();
    setReset(true);
    setValue('');
  };
  var createOption = function createOption(val) {
    var trimmed = val.toString().trim();
    return {
      children: trimmed,
      key: generateKey(),
      label: trimmed,
      value: trimmed,
      type: 'create'
    };
  };
  var createTagFromValue = function createTagFromValue(val) {
    var option = createOption(val);
    var newTags = [].concat(_toConsumableArray(tags), [option]);
    setTags(newTags);
    onTagged(newTags, 'create', option);
    resetTagger();
  };
  var createTagsFromValue = function createTagsFromValue(val) {
    // separate values on delimiter and filter out empty strings
    var values = val.toString().split(delimiter).filter(Boolean);
    var newTags = [].concat(_toConsumableArray(tags), _toConsumableArray(values.map(function (v) {
      return createOption(v);
    })));
    setTags(newTags);
    onTagged(newTags, 'create');
    resetTagger();
  };
  var onSelection = function onSelection(option, _, val) {
    if (option) {
      var newTags = [].concat(_toConsumableArray(tags), [option]);
      setTags(newTags);
      onTagged(newTags, 'select', option);
    } else if (allowCustomValue && val) {
      if (allowDelimited && delimiter.test(val.toString())) {
        createTagsFromValue(val);
      } else {
        createTagFromValue(val);
      }
    }
    resetTagger();
    setTimeout(function () {
      scrollToCombobox();
    }, 50);
  };
  var onRemove = function onRemove(key) {
    var option = tags.find(function (tag) {
      return tag.key === key;
    });
    var newTags = tags.filter(function (tag) {
      return tag.key !== key;
    });
    setTags(newTags);
    onTagged(newTags, 'remove', option);
    resetTagger();
    focusCombobox();
  };
  var removeAll = function removeAll() {
    setTags([]);
    resetTagger();
  };
  useEffect(function () {
    if (addTags && addTags.length > 0) {
      var newTags = [].concat(_toConsumableArray(tags), _toConsumableArray(addTags.map(function (tag) {
        tag.type = 'external';
        return tag;
      })));
      setTags(newTags);
    }
  }, [addTags]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (clearTags) {
      removeAll();
    }
  }, [clearTags]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (reset) {
      setReset(false);
    }
  }, [reset]);
  useEffect(function () {
    if (fakeTextareaRef.current) {
      var _fakeTextareaRef$curr, _fakeTextareaRef$curr2;
      setOverflow(((_fakeTextareaRef$curr = fakeTextareaRef.current) === null || _fakeTextareaRef$curr === void 0 ? void 0 : _fakeTextareaRef$curr.scrollHeight) > ((_fakeTextareaRef$curr2 = fakeTextareaRef.current) === null || _fakeTextareaRef$curr2 === void 0 ? void 0 : _fakeTextareaRef$curr2.clientHeight));
    }
  }, [(_fakeTextareaRef$curr3 = fakeTextareaRef.current) === null || _fakeTextareaRef$curr3 === void 0 ? void 0 : _fakeTextareaRef$curr3.scrollHeight, (_fakeTextareaRef$curr4 = fakeTextareaRef.current) === null || _fakeTextareaRef$curr4 === void 0 ? void 0 : _fakeTextareaRef$curr4.clientHeight]);
  useEffect(function () {
    if (toggleExpanded !== undefined) {
      setToggleExpanded(undefined);
    }
  }, [toggleExpanded]);
  var pillElement = 'p';
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-tagger': true,
      'bf-tagger__standard': true,
      'bf-tagger__standard--disabled': disabled,
      'bf-tagger__standard--error': hasError,
      'bf-tagger__standard--expanded': expanded,
      'bf-tagger__standard--focused': focused,
      'bf-tagger__standard--help-text': hasHelpText,
      'bf-tagger__standard--label-hidden': !showLabel
    }, _defineProperty(_classnames, "bf-tagger__standard--label-".concat(labelPosition), showLabel), _defineProperty(_classnames, "bf-tagger__standard--look-".concat(look), look), _defineProperty(_classnames, 'bf-tagger__standard--height', hasHeight), _defineProperty(_classnames, 'bf-tagger__standard--overflow', overflow), _defineProperty(_classnames, 'bf-tagger__standard--readonly', readOnly), _defineProperty(_classnames, 'bf-tagger__standard--required', hasRequired), _defineProperty(_classnames, 'bf-tagger__standard--selected-all', selectedAllTags), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    "data-testid": textfieldWrapperId,
    id: textfieldWrapperId,
    labelPosition: labelPosition,
    onClick: enabled ? function (e) {
      var target = e.target;
      var tagName = target.tagName;
      // exclude focusing on the combobox when clicking on a pill
      // so that users can copy the pill text, if needed
      if (![pillElement.toUpperCase()].includes(tagName)) {
        focusCombobox();
      }
      if (otherProps !== null && otherProps !== void 0 && otherProps.onClick) {
        otherProps.onClick(e);
      }
    } : undefined,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(TextfieldHeader, _extends({}, headerProps, {
    className: classnames(_defineProperty({
      'bf-tagger__header': true
    }, "".concat(headerProps === null || headerProps === void 0 ? void 0 : headerProps.className), !!(headerProps !== null && headerProps !== void 0 && headerProps.className))),
    error: duplicate ? duplicateOptionLabel : error,
    errorProps: errorProps,
    htmlFor: "".concat(id, "-combobox"),
    inlineAlertId: inlineAlertId,
    label: label,
    labelId: labelId,
    labelPosition: labelPosition,
    labelProps: labelProps,
    required: required,
    requiredLabel: requiredLabel,
    showLabel: showLabel
  })), /*#__PURE__*/React.createElement(TextfieldBody, _extends({}, bodyProps, {
    className: classnames(_defineProperty({
      'bf-tagger__body': true
    }, "".concat(bodyProps === null || bodyProps === void 0 ? void 0 : bodyProps.className), !!(bodyProps !== null && bodyProps !== void 0 && bodyProps.className))),
    error: duplicate ? duplicateOptionLabel : error,
    errorProps: errorProps,
    helpText: helpText,
    helpTextId: helpTextId,
    helpTextProps: helpTextProps,
    inlineAlertId: inlineAlertId,
    labelPosition: labelPosition
  }), /*#__PURE__*/React.createElement(FakeTextarea, _extends({}, textareaProps, {
    "data-testid": textareaId,
    disabled: disabled,
    error: duplicate ? duplicateOptionLabel : error,
    focused: focused,
    id: textareaId,
    look: look,
    readOnly: readOnly,
    ref: fakeTextareaRef
  }), tags.map(function (tag, index) {
    var current = index === selectedTagIndex;
    var currentOrSelectedAll = selectedAllTags || current;
    return /*#__PURE__*/React.createElement(StandardPill, {
      "aria-current": current || undefined,
      backgroundColor: enabled ? BrandfolderHexColors.DirtyMarshmallow : BrandfolderHexColors.Gray,
      borderColor: enabled && currentOrSelectedAll ? BrandfolderHexColors.GrayMediumDark : enabled ? BrandfolderHexColors.DirtyMarshmallow : BrandfolderHexColors.Gray,
      closeButtonAriaLabel: removeTagLabel,
      fontColor: BrandfolderHexColors.Text,
      element: pillElement,
      ellipsis: false,
      error: tag.error,
      key: tag.key,
      onClose: enabled ? function () {
        onRemove(tag.key);
      } : undefined,
      size: PillSize.Large
    }, tagFormatter ? tagFormatter(tag) : tag.children);
  }), /*#__PURE__*/React.createElement(StandardCombobox, _extends({}, comboboxProps, {
    allowCustomValue: allowCustomValue,
    clearAfterCustomValue: true,
    reset: reset,
    comboboxTextareaProps: _objectSpread(_objectSpread({}, comboboxProps === null || comboboxProps === void 0 ? void 0 : comboboxProps.comboboxTextareaProps), {}, {
      onBlur: function onBlur(e) {
        var _comboboxProps$combob;
        deselectTags();
        setFocused(false);
        if (allowCustomValue && allowTagsOnBlur && !clickedInside && value) {
          if (allowDelimited && delimiter.test(value.toString())) {
            createTagsFromValue(value);
          } else {
            createTagFromValue(value);
          }
        }
        if (comboboxProps !== null && comboboxProps !== void 0 && (_comboboxProps$combob = comboboxProps.comboboxTextareaProps) !== null && _comboboxProps$combob !== void 0 && _comboboxProps$combob.onBlur) {
          var _comboboxProps$combob2;
          comboboxProps === null || comboboxProps === void 0 || (_comboboxProps$combob2 = comboboxProps.comboboxTextareaProps) === null || _comboboxProps$combob2 === void 0 || _comboboxProps$combob2.onBlur(e);
        }
      },
      onChange: function onChange(e) {
        var _comboboxProps$combob3;
        var target = e.target;
        deselectTags();
        setValue(target.value);
        if (!allowDuplicates) {
          var manualDuplicate = !!tags.some(function (tag) {
            return duplicateCheck ? duplicateCheck({
              locale: locale,
              tag: tag,
              value: target.value
            }) : DEFAULT_DUPLICATE_CHECK({
              locale: locale,
              tag: tag,
              value: target.value
            });
          });
          setDuplicate(manualDuplicate);
        }
        if (comboboxProps !== null && comboboxProps !== void 0 && (_comboboxProps$combob3 = comboboxProps.comboboxTextareaProps) !== null && _comboboxProps$combob3 !== void 0 && _comboboxProps$combob3.onChange) {
          var _comboboxProps$combob4;
          comboboxProps === null || comboboxProps === void 0 || (_comboboxProps$combob4 = comboboxProps.comboboxTextareaProps) === null || _comboboxProps$combob4 === void 0 || _comboboxProps$combob4.onChange(e);
        }
      },
      onFocus: function onFocus(e) {
        var _comboboxProps$combob5;
        setFocused(true);
        if (comboboxProps !== null && comboboxProps !== void 0 && (_comboboxProps$combob5 = comboboxProps.comboboxTextareaProps) !== null && _comboboxProps$combob5 !== void 0 && _comboboxProps$combob5.onFocus) {
          var _comboboxProps$combob6;
          comboboxProps === null || comboboxProps === void 0 || (_comboboxProps$combob6 = comboboxProps.comboboxTextareaProps) === null || _comboboxProps$combob6 === void 0 || _comboboxProps$combob6.onFocus(e);
        }
      },
      onKeyDown: function onKeyDown(e) {
        var _comboboxProps$combob7;
        var ctrlKey = e.ctrlKey,
          key = e.key,
          metaKey = e.metaKey;
        if (allowBackspaceRemove && hasTags && !hasValue && (ctrlKey || metaKey) && key === 'a') {
          setSelectedAllTags(true);
          setToggleExpanded(false);
        }
        if (key === 'ArrowDown' || key === 'ArrowUp') {
          deselectTags();
          scrollToCombobox();
        }
        if (comboboxProps !== null && comboboxProps !== void 0 && (_comboboxProps$combob7 = comboboxProps.comboboxTextareaProps) !== null && _comboboxProps$combob7 !== void 0 && _comboboxProps$combob7.onKeyDown) {
          var _comboboxProps$combob8;
          comboboxProps === null || comboboxProps === void 0 || (_comboboxProps$combob8 = comboboxProps.comboboxTextareaProps) === null || _comboboxProps$combob8 === void 0 || _comboboxProps$combob8.onKeyDown(e);
        }
      },
      onKeyUp: function onKeyUp(e) {
        var _comboboxProps$combob9;
        var key = e.key;
        if (allowCustomValue && allowDelimited && delimiter.test(value.toString())) {
          createTagsFromValue(value);
        }
        if (allowBackspaceRemove && hasTags) {
          switch (key) {
            case 'ArrowLeft':
              {
                if (!hasValue && !selectedAllTags) {
                  setToggleExpanded(false);
                  if (selectedTagIndex === undefined) {
                    setSelectedTagIndex(lastTagIndex);
                  } else if (selectedTagIndex !== 0) {
                    setSelectedTagIndex(selectedTagIndex - 1);
                  }
                  // if selectedTagIndex === 0, do nothing (can't go further left)
                }

                break;
              }
            case 'ArrowRight':
              {
                if (!hasValue && !selectedAllTags) {
                  setSelectedAllTags(false);
                  if (selectedTagIndex === lastTagIndex) {
                    setSelectedTagIndex(undefined);
                  } else if (hasSelectedTagIndex) {
                    setSelectedTagIndex(selectedTagIndex + 1);
                  }
                  // if selectedTagIndex === undefined, do nothing (can't go right)
                }

                break;
              }
            case 'Backspace':
            case 'Delete':
              {
                if (selectedAllTags || hasSelectedTagIndex || !hasValueDebounced) {
                  if (selectedAllTags) {
                    removeAll();
                  } else if (hasSelectedTagIndex) {
                    onRemove(tags[selectedTagIndex].key);
                  } else if (!hasValueDebounced) {
                    // eslint-disable-next-line unicorn/prefer-at
                    onRemove(tags[tags.length - 1].key);
                  }
                }
                break;
              }
            case 'Escape':
              {
                deselectTags();
                break;
              }
          }
        }
        if (comboboxProps !== null && comboboxProps !== void 0 && (_comboboxProps$combob9 = comboboxProps.comboboxTextareaProps) !== null && _comboboxProps$combob9 !== void 0 && _comboboxProps$combob9.onKeyUp) {
          var _comboboxProps$combob10;
          comboboxProps === null || comboboxProps === void 0 || (_comboboxProps$combob10 = comboboxProps.comboboxTextareaProps) === null || _comboboxProps$combob10 === void 0 || _comboboxProps$combob10.onKeyUp(e);
        }
      },
      onPaste: function onPaste(e) {
        var _comboboxProps$combob11;
        deselectTags();
        var pasted = e.clipboardData.getData('text');
        if (allowCustomValue && allowTagsOnPaste && pasted) {
          if (allowDelimited && delimiter.test(pasted.toString())) {
            createTagsFromValue(pasted);
          } else {
            createTagFromValue(pasted);
          }
          e.preventDefault(); // stops onChange when pasting
        }

        if (comboboxProps !== null && comboboxProps !== void 0 && (_comboboxProps$combob11 = comboboxProps.comboboxTextareaProps) !== null && _comboboxProps$combob11 !== void 0 && _comboboxProps$combob11.onPaste) {
          var _comboboxProps$combob12;
          comboboxProps === null || comboboxProps === void 0 || (_comboboxProps$combob12 = comboboxProps.comboboxTextareaProps) === null || _comboboxProps$combob12 === void 0 || _comboboxProps$combob12.onPaste(e);
        }
      },
      ref: comboboxTextareaRef
    }),
    disabled: disabled,
    disabledOptions: tags,
    duplicate: duplicate,
    inlineAlertId: inlineAlertId,
    editable: true,
    error: duplicate ? duplicateOptionLabel : error,
    helpText: helpText,
    helpTextId: helpTextId,
    id: id,
    labelId: labelId,
    labels: {
      emptyLabel: emptyLabel,
      iconButtonLabel: iconButtonLabel,
      label: '',
      listboxLabel: listboxLabel,
      loaderLabel: loaderLabel,
      requiredLabel: '' // intentionally blank
    },

    loading: loading,
    locale: locale,
    onExpanded: setExpanded,
    onSelection: onSelection,
    options: options,
    parentScrolls: hasHeight,
    readOnly: readOnly,
    required: required,
    search: search,
    showIconButton: false,
    showLoadingOption: true,
    showPlaceholderOption: false,
    tagger: true,
    toggleExpanded: toggleExpanded
  })))));
};
var getHeight = function getHeight(height) {
  if (height === undefined) return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      min-height: 142px;\n    "])));
  return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: ", "px;\n    overflow-y: auto;\n  "])), height);
};
var Tagger = styled(BaseStandardTagger)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  .bf-tagger__tags {\n    flex-shrink: 0;\n    max-width: 100%;\n  }\n\n  .bf-textarea__fake {\n    align-content: flex-start;\n    align-items: flex-start;\n    display: flex;\n    flex-wrap: wrap;\n    padding: 5px;\n    ", "\n  }\n\n  &.bf-tagger__standard--expanded.bf-tagger__standard--height.bf-tagger__standard--overflow {\n    .bf-textarea__fake {\n      overflow: hidden;\n    }\n  }\n\n  .bf-combobox__standard {\n    flex: 1;\n    margin: 3px 0 0;\n    max-width: 100%;\n    min-width: 280px;\n  }\n\n  .bf-combobox__combobox {\n    border: 0;\n    min-height: 0;\n    padding: 10px;\n  }\n\n  .bf-listbox__standard {\n    width: 280px;\n  }\n\n  .bf-pill__standard {\n    align-items: center;\n    cursor: default;\n    height: auto;\n    margin: 5px;\n    padding: 7px 7px 7px 10px;\n\n    .bf-pill__content {\n      height: auto;\n      line-height: 20px;\n      overflow-wrap: anywhere;\n      padding: 0;\n    }\n\n    .bf-pill__close-button {\n      height: 15px;\n      margin-top: 1px;\n      margin-inline-start: 7px;\n      padding: 0;\n      width: 15px;\n\n      .bf-pill__close-icon {\n        font-size: 10px;\n      }\n    }\n  }\n"])), function (_ref) {
  var height = _ref.height;
  return getHeight(height);
});
/**
 * A component for creating and displaying tags selected from a `<StandardCombobox>`.
 *
 * @param props StandardTaggerProps
 * @returns FunctionComponent<StandardTaggerProps>
 */
var StandardTagger = function StandardTagger(props) {
  var _props$allowBackspace = props.allowBackspaceRemove,
    allowBackspaceRemove = _props$allowBackspace === void 0 ? true : _props$allowBackspace,
    _props$allowCustomVal = props.allowCustomValue,
    allowCustomValue = _props$allowCustomVal === void 0 ? true : _props$allowCustomVal,
    _props$allowDelimited = props.allowDelimited,
    allowDelimited = _props$allowDelimited === void 0 ? true : _props$allowDelimited,
    _props$allowDuplicate = props.allowDuplicates,
    allowDuplicates = _props$allowDuplicate === void 0 ? true : _props$allowDuplicate,
    _props$allowTagsOnBlu = props.allowTagsOnBlur,
    allowTagsOnBlur = _props$allowTagsOnBlu === void 0 ? true : _props$allowTagsOnBlu,
    _props$allowTagsOnPas = props.allowTagsOnPaste,
    allowTagsOnPaste = _props$allowTagsOnPas === void 0 ? true : _props$allowTagsOnPas,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    _props$search = props.search,
    search = _props$search === void 0 ? true : _props$search,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Tagger, _extends({}, otherProps, {
    allowBackspaceRemove: allowBackspaceRemove,
    allowDelimited: allowDelimited,
    allowCustomValue: allowCustomValue,
    allowDuplicates: allowDuplicates,
    allowTagsOnBlur: allowTagsOnBlur,
    allowTagsOnPaste: allowTagsOnPaste,
    labelPosition: labelPosition,
    look: look,
    search: search,
    showLabel: showLabel
  })));
};
export { BaseStandardTagger, DEFAULT_DELIMITER, DEFAULT_DUPLICATE_CHECK, StandardTagger };